export const getParentPathname = (pathname: string) => {
  let preparedPathname = pathname

  if (
    pathname != null &&
    pathname.length > 0 &&
    pathname[pathname.length - 1] !== '/'
  ) {
    preparedPathname += '/'
  }

  return new URL('..', window.location.origin + preparedPathname).pathname
}
